import { matchPath } from "react-router-dom";
import { injectIntl } from "react-intl";
import { useEffect } from "react";
import { browserShape, withBrowser } from "../../context";

type Props = {
  match?: {
    params?: string[];
  };
  browser: browserShape;
};

export function RedirectToApp({ match, browser }: Props) {
  useEffect(() => {
    const pathWhitelist = [
      "/assets/*",
      "/instrumentations/*",
      "/subscription/*",
      "/subscription",
      "/nodes/*",
      "/map",
      "/support/*",
      "/upgrade",
      "/feedback",
    ];

    const checkPathInWhitelist = (pathToCheck: $TSFixMe) =>
      pathWhitelist.some((whitelistPath) =>
        matchPath(pathToCheck, {
          path: whitelistPath,
          exact: true,
          strict: false,
        }),
      );

    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const path = match.params[0];
    if (checkPathInWhitelist(`/${path}`)) {
      browser.navigateTo(`/${path}`);
    } else {
      browser.navigateTo("/");
    }
  }, [match]);

  return <div>...</div>;
}

// @ts-expect-error TS(2345) FIXME: Argument of type 'FC<WithIntlProps<WrappedComponen... Remove this comment to see the full error message
export default withBrowser(injectIntl(RedirectToApp));
